// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.m1YxRLP2ZhcuU4VT {
    position: relative;

    min-width: 550px;
    height: 210px;
}

.f5OueQGQEME6EEru, .gRDG0QR8VZYGkUTq, .h18W4VzdbzoNzg2g, .aBrreFaxWf8AGDxH {
    display: flex;
    align-items: center;
    gap: var(--lok-spacing-2);

    color: var(--lok-color-text-link-hover);
    font: var(--lok-typography-body-small-strong);
    background-color: var(--lok-color-background-active);
    padding: var(--lok-spacing-2) var(--lok-spacing-5);
    border-radius: 20px;

    box-shadow: 0px 10px 20px 2px #26262605,
                0px 8px 16px 0px #2626260A,
                0px 4px 6px 0px #2626260A,
                0px 0px 2px 0px #2626261A;
}

.f5OueQGQEME6EEru {
    position: absolute;
    left: 5%;
    top: 14%;
}

.gRDG0QR8VZYGkUTq {
    position: absolute;
    top: 0;
    right: 10%;
}

.h18W4VzdbzoNzg2g {
    position: absolute;
    left: 0;
    bottom: 12%;
}

.aBrreFaxWf8AGDxH {
    position: absolute;
    right: 0;
    bottom: 0;
}

.HEwggkEe3Yg_7UfD {
    position: absolute;
    right: 15%;
    top: 40%;
}
`, "",{"version":3,"sources":["webpack://./packages/rag/src/components/IrregularButtonLayout/IrregularButtonLayout.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;;IAElB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;;IAEzB,uCAAuC;IACvC,6CAA6C;IAC7C,oDAAoD;IACpD,kDAAkD;IAClD,mBAAmB;;IAEnB;;;yCAGqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;AACZ","sourcesContent":[".container {\n    position: relative;\n\n    min-width: 550px;\n    height: 210px;\n}\n\n.legal, .blog, .support, .marketing {\n    display: flex;\n    align-items: center;\n    gap: var(--lok-spacing-2);\n\n    color: var(--lok-color-text-link-hover);\n    font: var(--lok-typography-body-small-strong);\n    background-color: var(--lok-color-background-active);\n    padding: var(--lok-spacing-2) var(--lok-spacing-5);\n    border-radius: 20px;\n\n    box-shadow: 0px 10px 20px 2px #26262605,\n                0px 8px 16px 0px #2626260A,\n                0px 4px 6px 0px #2626260A,\n                0px 0px 2px 0px #2626261A;\n}\n\n.legal {\n    position: absolute;\n    left: 5%;\n    top: 14%;\n}\n\n.blog {\n    position: absolute;\n    top: 0;\n    right: 10%;\n}\n\n.support {\n    position: absolute;\n    left: 0;\n    bottom: 12%;\n}\n\n.marketing {\n    position: absolute;\n    right: 0;\n    bottom: 0;\n}\n\n.button {\n    position: absolute;\n    right: 15%;\n    top: 40%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `m1YxRLP2ZhcuU4VT`,
	"legal": `f5OueQGQEME6EEru`,
	"blog": `gRDG0QR8VZYGkUTq`,
	"support": `h18W4VzdbzoNzg2g`,
	"marketing": `aBrreFaxWf8AGDxH`,
	"button": `HEwggkEe3Yg_7UfD`
};
export default ___CSS_LOADER_EXPORT___;
